<template>
  <el-dialog
    title="选择店铺"
    width="520px"
    :visible.sync="dialogStore.isShow"
    append-to-body
    @open='open'
  >
    <el-form :inline="true" @submit.native.prevent>      
      <el-form-item >
        <el-input  placeholder="店铺名称" size="medium" @keyup.enter.native="Search" v-model="serch.name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" v-on:click="Search" >查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" style="width: 100%">
      <el-table-column  prop="Name" :show-overflow-tooltip="true" label="名称"> </el-table-column>
      <el-table-column  prop="BusinessName" :show-overflow-tooltip="true" label="所属商家"> </el-table-column>
      <el-table-column  fixed="right" width="70px" label="操作" >
        <template slot-scope="scope">
          <el-button @click.native.prevent="Select(scope.row)" type="text" size="small">
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :page-size="serch.pagesize"
      :total="serch.totalCount">
    </el-pagination>
  </el-dialog>
</template>
<script  type='text/ecmascript-6'>
   import { Loading } from 'element-ui';
   export default {
    props:{
      dialogStore:{        
      }
    },
    data(){
      return {
        
        rows:[],
        loading:false,
        serch:{          
          name:'',
          pageIndex:1,
          pagesize:5,
          totalCount:0,
          sort:' id desc',
        }
      }
    },
    mounted(){
      
    },
    methods:{
      open:function(){
        this.GetData()
      },
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/ChainStore/Index',
          params: that.serch
        }).then(function (resp) {
          that.serch.totalCount = resp.data.totalCount
          that.rows = resp.data.chainStores
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleCurrentChange(val) {
        this.serch.pageIndex = val 
        this.GetData()
      },
      Select(row){ 
        this.$emit('UpdateSote',row.Id,row.Name,row.MerchantId,row.BusinessName)
        this.dialogStore.isShow = false
      }

    }
   }
</script>
